import { render, staticRenderFns } from "./ToggleSwitch.vue?vue&type=template&id=1c94ece8&scoped=true"
import script from "./ToggleSwitch.vue?vue&type=script&lang=js"
export * from "./ToggleSwitch.vue?vue&type=script&lang=js"
import style0 from "./ToggleSwitch.vue?vue&type=style&index=0&id=1c94ece8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c94ece8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c94ece8')) {
      api.createRecord('1c94ece8', component.options)
    } else {
      api.reload('1c94ece8', component.options)
    }
    module.hot.accept("./ToggleSwitch.vue?vue&type=template&id=1c94ece8&scoped=true", function () {
      api.rerender('1c94ece8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ToggleSwitch.vue"
export default component.exports